export const AirlineData = [

 {
  "airlinecode": "2B",
  "airlinename": "Aerocondor"
 },
 {
  "airlinecode": "2C",
  "airlinename": "SNCF"
 },
 {
  "airlinecode": "2E",
  "airlinename": "Smokey Bay Air"
 },
 {
  "airlinecode": "2F",
  "airlinename": "Frontier Flying Service"
 },
 {
  "airlinecode": "2H",
  "airlinename": "European Airlines"
 },
 {
  "airlinecode": "2J",
  "airlinename": "Air Burkina"
 },
 {
  "airlinecode": "2L",
  "airlinename": "Lineas Aereas Entre Rios"
 },
 {
  "airlinecode": "2M",
  "airlinename": "Moldavian Airlines"
 },
 {
  "airlinecode": "2N",
  "airlinename": "Next Jet"
 },
 {
  "airlinecode": "2R",
  "airlinename": "VIA Rail"
 },
 {
  "airlinecode": "2T",
  "airlinename": "Canada 3000 Airline Limited"
 },
 {
  "airlinecode": "2V",
  "airlinename": "AMTRAK"
 },
 {
  "airlinecode": "2Y",
  "airlinename": "Air Andaman"
 },
 {
  "airlinecode": "34",
  "airlinename": "TestAirLine"
 },
 {
  "airlinecode": "3B",
  "airlinename": "Avior"
 },
 {
  "airlinecode": "3C",
  "airlinename": "Corporate Express Airlines"
 },
 {
  "airlinecode": "3D",
  "airlinename": "Denim Air"
 },
 {
  "airlinecode": "3F",
  "airlinename": "Pacific Airways"
 },
 {
  "airlinecode": "3G",
  "airlinename": "Atlant-Soyuz"
 },
 {
  "airlinecode": "3H",
  "airlinename": "Air Inuit"
 },
 {
  "airlinecode": "3K",
  "airlinename": "Tatonduk Fly"
 },
 {
  "airlinecode": "3M",
  "airlinename": "Gulfstream Intl Airlines"
 },
 {
  "airlinecode": "3N",
  "airlinename": "Air Urga"
 },
 {
  "airlinecode": "3P",
  "airlinename": "Inter Tropical Aviation"
 },
 {
  "airlinecode": "3Q",
  "airlinename": "China Yunnan Airlines"
 },
 {
  "airlinecode": "3R",
  "airlinename": "Avia Air"
 },
 {
  "airlinecode": "3T",
  "airlinename": "Turan Air"
 },
 {
  "airlinecode": "3U",
  "airlinename": "Sichuan Airlines"
 },
 {
  "airlinecode": "3W",
  "airlinename": "Wanair"
 },
 {
  "airlinecode": "3X",
  "airlinename": "Japan Air Commuter"
 },
 {
  "airlinecode": "3Z",
  "airlinename": "Necon Air"
 },
 {
  "airlinecode": "4A",
  "airlinename": "Royal Bengal Airline"
 },
 {
  "airlinecode": "4B",
  "airlinename": "Olson Air Service"
 },
 {
  "airlinecode": "4D",
  "airlinename": "Air Sinai"
 },
 {
  "airlinecode": "4E",
  "airlinename": "Tanana Air"
 },
 {
  "airlinecode": "4F",
  "airlinename": "Air City"
 },
 {
  "airlinecode": "4G",
  "airlinename": "Shenzhen Airlines"
 },
 {
  "airlinecode": "4H",
  "airlinename": "Fly"
 },
 {
  "airlinecode": "4K",
  "airlinename": "Kenn Borek"
 },
 {
  "airlinecode": "4L",
  "airlinename": "EuroLine"
 },
 {
  "airlinecode": "4N",
  "airlinename": "Air North"
 },
 {
  "airlinecode": "1B",
  "airlinename": "BH Air"
 },
 {
  "airlinecode": "K2",
  "airlinename": "Euro Lot"
 },
 {
  "airlinecode": "H1",
  "airlinename": "Han Air"
 },
 {
  "airlinecode": "4P",
  "airlinename": "Business Aviation"
 },
 {
  "airlinecode": "4Q",
  "airlinename": "SAFI AIRWAYS"
 },
 {
  "airlinecode": "4R",
  "airlinename": "Orient Eagle Airways"
 },
 {
  "airlinecode": "4U",
  "airlinename": "TAVAJ-Transportes Aereos Regulares S. A."
 },
 {
  "airlinecode": "4V",
  "airlinename": "Voyageur Airways"
 },
 {
  "airlinecode": "4W",
  "airlinename": "Warbelow Air"
 },
 {
  "airlinecode": "5A",
  "airlinename": "Alpine Aviat"
 },
 {
  "airlinecode": "5B",
  "airlinename": "Tie Aviation"
 },
 {
  "airlinecode": "5D",
  "airlinename": "Aerolitoral S.A. de C.V."
 },
 {
  "airlinecode": "5E",
  "airlinename": "Base Airlines"
 },
 {
  "airlinecode": "5J",
  "airlinename": "Cebu Pacific"
 },
 {
  "airlinecode": "5K",
  "airlinename": "Odessa Airlines"
 },
 {
  "airlinecode": "5L",
  "airlinename": "Aerosur"
 },
 {
  "airlinecode": "5M",
  "airlinename": "Sibaviatrans"
 },

 {
  "airlinecode": "5Q",
  "airlinename": "Euroceltic Airways"
 },
 {
  "airlinecode": "5R",
  "airlinename": "IRS Aero"
 },
 {
  "airlinecode": "5T",
  "airlinename": "Canadian North"
 },
 {
  "airlinecode": "5V",
  "airlinename": "Lviv Airlines"
 },
 {
  "airlinecode": "5W",
  "airlinename": "Platinum Air 2000"
 },
 {
  "airlinecode": "6A",
  "airlinename": "Aviacsa-Consorcio Aviaxsa"
 },
 {
  "airlinecode": "6C",
  "airlinename": "Cape Smythe Air Service"
 },
 {
  "airlinecode": "6G",
  "airlinename": "Air Wales"
 },
 {
  "airlinecode": "6H",
  "airlinename": "Israir"
 },

 {
  "airlinecode": "6K",
  "airlinename": "Asian Spirit"
 },
 {
  "airlinecode": "6L",
  "airlinename": "Aklak Air"
 },
 {
  "airlinecode": "6N",
  "airlinename": "Trans Travel Airlines"
 },
 {
  "airlinecode": "6Q",
  "airlinename": "Slovak Airlines"
 },
 {
  "airlinecode": "6S",
  "airlinename": "Proteus Helicopteres"
 },
 {
  "airlinecode": "6T",
  "airlinename": "Air Mandalay"
 },
 {
  "airlinecode": "6U",
  "airlinename": "Air Ukraine"
 },
 {
  "airlinecode": "6V",
  "airlinename": "Lignes Aeriennes Congolaises"
 },
 {
  "airlinecode": "6W",
  "airlinename": "Saratov Airlines"
 },
 {
  "airlinecode": "7B",
  "airlinename": "Krasnoyarsk Airlines"
 },
 {
  "airlinecode": "7D",
  "airlinename": "Donbass Eastern Ukranian Airlines"
 },
 {
  "airlinecode": "7E",
  "airlinename": "Sylt Air"
 },
 {
  "airlinecode": "7F",
  "airlinename": "Firstair"
 },
 {
  "airlinecode": "7G",
  "airlinename": "Bellair"
 },
 {
  "airlinecode": "7I",
  "airlinename": "Nordic East Airlink"
 },
 {
  "airlinecode": "7J",
  "airlinename": "Skagway Air"
 },
 {
  "airlinecode": "6E",
  "airlinename": "Indigo"
 },
 {
  "airlinecode": "7K",
  "airlinename": "Kogalymavia"
 },
 {
  "airlinecode": "7M",
  "airlinename": "Tyumen Airlines"
 },
 {
  "airlinecode": "7N",
  "airlinename": "Inland Aviations Services"
 },
 {
  "airlinecode": "7O",
  "airlinename": "Galaxy Air"
 },
 {
  "airlinecode": "7Q",
  "airlinename": "Air Venezuela"
 },
 {
  "airlinecode": "7S",
  "airlinename": "Arctic Transportation Services"
 },
 {
  "airlinecode": "7T",
  "airlinename": "Trans Cote"
 },
 {
  "airlinecode": "7W",
  "airlinename": "Wind Rose Aviation Company"
 },
 {
  "airlinecode": "7Y",
  "airlinename": "European Aie Express"
 },
 {
  "airlinecode": "7Z",
  "airlinename": "L B Limited"
 },
 {
  "airlinecode": "8A",
  "airlinename": "Arctic Air"
 },
 {
  "airlinecode": "8B",
  "airlinename": "Caribbean Star Airlines"
 },
 {
  "airlinecode": "8C",
  "airlinename": "Shanxi Airlines"
 },
 {
  "airlinecode": "8D",
  "airlinename": "Volare Airlines"
 },
 {
  "airlinecode": "8E",
  "airlinename": "Bering Air"
 },
 {
  "airlinecode": "8F",
  "airlinename": "Fischer Air"
 },
 {
  "airlinecode": "8G",
  "airlinename": "Angel Airlines"
 },
 {
  "airlinecode": "8H",
  "airlinename": "Equaflight"
 },
 {
  "airlinecode": "8J",
  "airlinename": "Jet4You"
 },
 {
  "airlinecode": "8N",
  "airlinename": "Nordkalottlkyg"
 },
 {
  "airlinecode": "8O",
  "airlinename": "West Coast Air"
 },
 {
  "airlinecode": "8P",
  "airlinename": "Pacific Coastal"
 },
 {
  "airlinecode": "8Q",
  "airlinename": "Baker Aviatio"
 },
 {
  "airlinecode": "8T",
  "airlinename": "Air Tindi"
 },
 {
  "airlinecode": "8U",
  "airlinename": "Afriqiyah Airways"
 },
 {
  "airlinecode": "8V",
  "airlinename": "Wrightair Svc"
 },
 {
  "airlinecode": "8W",
  "airlinename": "Private Wings"
 },
 {
  "airlinecode": "8Z",
  "airlinename": "Laser"
 },
 {
  "airlinecode": "9A",
  "airlinename": "Visa Airways"
 },
 {
  "airlinecode": "9B",
  "airlinename": "ACCESRAIL"
 },
 {
  "airlinecode": "9C",
  "airlinename": "Gill Airways"
 },
 {
  "airlinecode": "9E",
  "airlinename": "Express Airlines"
 },
 {
  "airlinecode": "9F",
  "airlinename": "Eurostar"
 },
 {
  "airlinecode": "9G",
  "airlinename": "Galaxy Airways"
 },
 {
  "airlinecode": "9J",
  "airlinename": "Pacific Island Aviation"
 },
 {
  "airlinecode": "9K",
  "airlinename": "Cape Air"
 },
 {
  "airlinecode": "9L",
  "airlinename": "Colgan Air"
 },
 {
  "airlinecode": "9M",
  "airlinename": "Central Mountain Air"
 },
 {
  "airlinecode": "9N",
  "airlinename": "Trans State Airlines"
 },
 {
  "airlinecode": "9T",
  "airlinename": "Transwest Air"
 },
 {
  "airlinecode": "9U",
  "airlinename": "Air Moldova"
 },
 {
  "airlinecode": "9V",
  "airlinename": "Vip Air"
 },
 {
  "airlinecode": "9W",
  "airlinename": "Jet Airways"
 },
 {
  "airlinecode": "7L",
  "airlinename": "Silk Way West Airlines"
 },
 {
  "airlinecode": "9Y",
  "airlinename": "Air Kazakstan"
 },
 {
  "airlinecode": "A3",
  "airlinename": "Aegean Airlines"
 },
 {
  "airlinecode": "A4",
  "airlinename": "Southern Wind"
 },
 {
  "airlinecode": "A5",
  "airlinename": "Tikal Jets, S.A."
 },
 {
  "airlinecode": "A6",
  "airlinename": "Air Alps Aviation"
 },
 {
  "airlinecode": "A7",
  "airlinename": "Air Comet"
 },
 {
  "airlinecode": "A8",
  "airlinename": "Aerolineas Paraguayas"
 },
 {
  "airlinecode": "AA",
  "airlinename": "American Airlines "
 },
 {
  "airlinecode": "AB",
  "airlinename": "Air Berlin"
 },
 {
  "airlinecode": "AC",
  "airlinename": "Air Canada"
 },
 {
  "airlinecode": "AE",
  "airlinename": "Mandarin Airlines"
 },
 {
  "airlinecode": "AF",
  "airlinename": "Air France"
 },
 {
  "airlinecode": "AI",
  "airlinename": "Air India"
 },
 {
  "airlinecode": "AJ",
  "airlinename": "AeroContractors"
 },
 {
  "airlinecode": "AK",
  "airlinename": "Airasia"
 },
 {
  "airlinecode": "AL",
  "airlinename": "Astral Aviation"
 },
 {
  "airlinecode": "AN",
  "airlinename": "Ansett Australia"
 },
 {
  "airlinecode": "AO",
  "airlinename": "Australian Airlines"
 },
 {
  "airlinecode": "AQ",
  "airlinename": "Aloha Airline"
 },
 {
  "airlinecode": "AR",
  "airlinename": "Aerolineas Argentinas"
 },
 {
  "airlinecode": "AS",
  "airlinename": "Alaska Airlines"
 },
 {
  "airlinecode": "AT",
  "airlinename": "Royal Air Maroc"
 },
 {
  "airlinecode": "AU",
  "airlinename": "Austral Lineas Aereas Sa"
 },
 {
  "airlinecode": "AX",
  "airlinename": "American Connection"
 },
 {
  "airlinecode": "AY",
  "airlinename": "Finnair"
 },
 {
  "airlinecode": "B3",
  "airlinename": "Bellview"
 },
 {
  "airlinecode": "B4",
  "airlinename": "B.A.C.H Flugbetrieb"
 },
 {
  "airlinecode": "BA",
  "airlinename": "British Airways"
 },
 {
  "airlinecode": "BB",
  "airlinename": "Seaborne Aviation"
 },
 {
  "airlinecode": "BC",
  "airlinename": "Skymark Airlines"
 },
 {
  "airlinecode": "BD",
  "airlinename": "BMI British Midland"
 },
 {
  "airlinecode": "BE",
  "airlinename": "British European"
 },
 {
  "airlinecode": "BG",
  "airlinename": "Biman Bangladesh Airlines"
 },
 {
  "airlinecode": "BH",
  "airlinename": "Hawkair"
 },
 {
  "airlinecode": "BL",
  "airlinename": "Pacific Airlines"
 },
 {
  "airlinecode": "BM",
  "airlinename": "Aero Traporti"
 },
 {
  "airlinecode": "BN",
  "airlinename": "Landair International Airlines"
 },
 {
  "airlinecode": "BO",
  "airlinename": "Bouraq Airlines"
 },
 {
  "airlinecode": "BP",
  "airlinename": "Air Botswana"
 },
 {
  "airlinecode": "BT",
  "airlinename": "Air Baltic"
 },
 {
  "airlinecode": "BU",
  "airlinename": "Braathens ASA"
 },
 {
  "airlinecode": "BV",
  "airlinename": "Blue Panorama Airlines"
 },
 {
  "airlinecode": "C3",
  "airlinename": "Icar"
 },
 {
  "airlinecode": "C5",
  "airlinename": "CommutAir"
 },
 {
  "airlinecode": "C7",
  "airlinename": "Aerocontinente Chile"
 },
 {
  "airlinecode": "C8",
  "airlinename": "Chicago Express Airlines"
 },
 {
  "airlinecode": "C9",
  "airlinename": "Cirrus Airlines"
 },
 {
  "airlinecode": "CA",
  "airlinename": "Air China"
 },
 {
  "airlinecode": "CB",
  "airlinename": "ScotAirways"
 },
 {
  "airlinecode": "CD",
  "airlinename": "Alliance-Air"
 },
 {
  "airlinecode": "CG",
  "airlinename": "Milne Bay Air"
 },
 {
  "airlinecode": "CH",
  "airlinename": "Bemidji Aviation"
 },
 {
  "airlinecode": "CJ",
  "airlinename": "China Northern Airlines"
 },
 {
  "airlinecode": "CN",
  "airlinename": "Islands Nationair"
 },
 {
  "airlinecode": "CO",
  "airlinename": "Continental Airlines"
 },
 {
  "airlinecode": "CP",
  "airlinename": "Canadian Airlines International"
 },
 {
  "airlinecode": "CS",
  "airlinename": "Continental Micronesia"
 },
 {
  "airlinecode": "CW",
  "airlinename": "Airline Of Marshall Islands"
 },
 {
  "airlinecode": "CY",
  "airlinename": "Cyprus Airways"
 },
 {
  "airlinecode": "D2",
  "airlinename": "Severstal"
 },
 {
  "airlinecode": "D3",
  "airlinename": "Daallo Airlines"
 },
 {
  "airlinecode": "D6",
  "airlinename": "Inter Aviatn"
 },
 {
  "airlinecode": "D7",
  "airlinename": "Dinar Lineas Aereas S.A."
 },
 {
  "airlinecode": "D8",
  "airlinename": "Djibouti Airlines"
 },
 {
  "airlinecode": "D9",
  "airlinename": "Aeroflot-Don"
 },
 {
  "airlinecode": "DB",
  "airlinename": "Brittany Air International"
 },
 {
  "airlinecode": "BR",
  "airlinename": "EVA Air"
 },
 {
  "airlinecode": "DC",
  "airlinename": "Golden Air Flyg Ab"
 },
 {
  "airlinecode": "DF",
  "airlinename": "Aebal"
 },
 {
  "airlinecode": "DG",
  "airlinename": "Island Airlines"
 },
 {
  "airlinecode": "DH",
  "airlinename": "Independence"
 },
 {
  "airlinecode": "DI",
  "airlinename": "Deutsche BA"
 },
 {
  "airlinecode": "DJ",
  "airlinename": "Virgin Blue"
 },
 {
  "airlinecode": "DK",
  "airlinename": "Eastland Air"
 },
 {
  "airlinecode": "DL",
  "airlinename": "Delta Air Lines"
 },
 {
  "airlinecode": "DM",
  "airlinename": "Maersk Air"
 },
 {
  "airlinecode": "DO",
  "airlinename": "Air Vallee"
 },
 {
  "airlinecode": "DP",
  "airlinename": "Air 2000 Limited"
 },
 {
  "airlinecode": "DQ",
  "airlinename": "Coastal Air Transport"
 },
 {
  "airlinecode": "DU",
  "airlinename": "Hemus Air"
 },
 {
  "airlinecode": "DX",
  "airlinename": "Danish Air Transport"
 },
 {
  "airlinecode": "dy",
  "airlinename": "NORWEGIAN AIR SHUTTLE"
 },
 {
  "airlinecode": "DZ",
  "airlinename": "Transcaraibes"
 },
 {
  "airlinecode": "E3",
  "airlinename": "Domodedovo Airlines"
 },
 {
  "airlinecode": "E4",
  "airlinename": "Aero Asia International"
 },
 {
  "airlinecode": "E5",
  "airlinename": "Samara Airlines"
 },
 {
  "airlinecode": "E6",
  "airlinename": "Aviaexpresscruise Airline"
 },
 {
  "airlinecode": "E8",
  "airlinename": "Alpi Eagles"
 },
 {
  "airlinecode": "EA",
  "airlinename": "European Regions Airlines"
 },
 {
  "airlinecode": "EC",
  "airlinename": "Heli Inter Riviera"
 },
 {
  "airlinecode": "ED",
  "airlinename": "Ccair"
 },
 {
  "airlinecode": "EF",
  "airlinename": "Far Eastern Air"
 },
 {
  "airlinecode": "EG",
  "airlinename": "Japan Asia Airways"
 },
 {
  "airlinecode": "EJ",
  "airlinename": "New England Airlines"
 },
 {
  "airlinecode": "EK",
  "airlinename": "Emirates Airlines"
 },
 {
  "airlinecode": "EL",
  "airlinename": "Air Nippon Co"
 },
 {
  "airlinecode": "EM",
  "airlinename": "Western Airlines"
 },
 {
  "airlinecode": "EN",
  "airlinename": "Air Dolomiti"
 },
 {
  "airlinecode": "EQ",
  "airlinename": "Transportes Aereos Militates Ecuat"
 },
 {
  "airlinecode": "EU",
  "airlinename": "Empresa Ecuatoriana De Aviacion Sa"
 },
 {
  "airlinecode": "EV",
  "airlinename": "Atlantic Southeast Airlines"
 },
 {
  "airlinecode": "EW",
  "airlinename": "Eurowings"
 },
 {
  "airlinecode": "EX",
  "airlinename": "Air Santo Domingo"
 },
 {
  "airlinecode": "EY",
  "airlinename": "Etihad Airways"
 },
 {
  "airlinecode": "EZ",
  "airlinename": "Sun-Air"
 },
 {
  "airlinecode": "F4",
  "airlinename": "Eureca"
 },
 {
  "airlinecode": "F5",
  "airlinename": "Cosmic Air"
 },
 {
  "airlinecode": "F7",
  "airlinename": "Flybaboo"
 },
 {
  "airlinecode": "F9",
  "airlinename": "Frontier Airlines"
 },
 {
  "airlinecode": "FD",
  "airlinename": "Thai AirAsia"
 },
 {
  "airlinecode": "FE",
  "airlinename": "Royal Khmer Airlines"
 },
 {
  "airlinecode": "FG",
  "airlinename": "Bakhtar Afghan Airlines"
 },
 {
  "airlinecode": "FI",
  "airlinename": "Icelandair"
 },
 {
  "airlinecode": "FK",
  "airlinename": "Keewatin Air"
 },
 {
  "airlinecode": "FL",
  "airlinename": "Airtran Airways"
 },
 {
  "airlinecode": "FM",
  "airlinename": "Shanghai Airlines"
 },
 {
  "airlinecode": "FR",
  "airlinename": "Ryan Air Dublin"
 },
 {
  "airlinecode": "FS",
  "airlinename": "Missionary Av"
 },
 {
  "airlinecode": "fv",
  "airlinename": "ROSSIYA-RUSSIAN AIRLINES"
 },
 {
  "airlinecode": "FW",
  "airlinename": "Fair"
 },
 {
  "airlinecode": "FY",
  "airlinename": "Northwest Reqional"
 },
 {
  "airlinecode": "G2",
  "airlinename": "Avirex Gabon"
 },
 {
  "airlinecode": "G4",
  "airlinename": "Allegiant Air"
 },
 {
  "airlinecode": "G7",
  "airlinename": "Gandalf Airlines"
 },
 {
  "airlinecode": "G8",
  "airlinename": "GoAir"
 },
 {
  "airlinecode": "G9",
  "airlinename": "Air Arabia"
 },
 {
  "airlinecode": "GC",
  "airlinename": "Gambia International Airlines"
 },
 {
  "airlinecode": "GE",
  "airlinename": "Transasia Airways"
 },
 {
  "airlinecode": "GF",
  "airlinename": "Gulf Air"
 },
 {
  "airlinecode": "GG",
  "airlinename": "Air Guyane"
 },
 {
  "airlinecode": "GH",
  "airlinename": "Ghana Airways Corporation"
 },
 {
  "airlinecode": "GK",
  "airlinename": "Go One Airways"
 },
 {
  "airlinecode": "GL",
  "airlinename": "Global International Airways Corp"
 },
 {
  "airlinecode": "GM",
  "airlinename": "Air Slovakia Bwj"
 },
 {
  "airlinecode": "GN",
  "airlinename": "Air Gabon"
 },
 {
  "airlinecode": "GR",
  "airlinename": "Aurigny Air Services"
 },
 {
  "airlinecode": "GU",
  "airlinename": "Aviateca S A"
 },
 {
  "airlinecode": "GW",
  "airlinename": "Air Lines Of Kuban"
 },
 {
  "airlinecode": "GY",
  "airlinename": "Guyana Airways Corporation"
 },
 {
  "airlinecode": "GZ",
  "airlinename": "Air Rarotonga"
 },
 {
  "airlinecode": "H4",
  "airlinename": "Inter Islands Airlines"
 },
 {
  "airlinecode": "H5",
  "airlinename": "Magadan Air"
 },
 {
  "airlinecode": "H6",
  "airlinename": "Hageland"
 },
 {
  "airlinecode": "H7",
  "airlinename": "Eagle Aviation Uganda"
 },
 {
  "airlinecode": "H8",
  "airlinename": "Dalavia-Far East Airways Khabarovsk"
 },
 {
  "airlinecode": "HA",
  "airlinename": "Hawaiian Airlines"
 },
 {
  "airlinecode": "HC",
  "airlinename": "Aero-Tropics Air Services"
 },
 {
  "airlinecode": "HD",
  "airlinename": "Hokkaido International Airlines"
 },
 {
  "airlinecode": "HE",
  "airlinename": "Lgw Luftfahrtgesellschaft"
 },
 {
  "airlinecode": "HF",
  "airlinename": "Hapag Lloyd"
 },
 {
  "airlinecode": "HG",
  "airlinename": "Harbor Airlines"
 },
 {
  "airlinecode": "HH",
  "airlinename": "Islandsflug"
 },
 {
  "airlinecode": "HI",
  "airlinename": "Papillon Air"
 },
 {
  "airlinecode": "HJ",
  "airlinename": "Swedeways Air Lines"
 },
 {
  "airlinecode": "HK",
  "airlinename": "Yangon Airways"
 },
 {
  "airlinecode": "HR",
  "airlinename": "Hahn Air"
 },
 {
  "airlinecode": "HS",
  "airlinename": "Skyways Regional"
 },
 {
  "airlinecode": "HT",
  "airlinename": "Royal Airways"
 },
 {
  "airlinecode": "HU",
  "airlinename": "Hainan Airlines"
 },
 {
  "airlinecode": "HV",
  "airlinename": "Transavia Airlines"
 },
 {
  "airlinecode": "HW",
  "airlinename": "North Wright"
 },
 {
  "airlinecode": "HY",
  "airlinename": "Uzbekistan Airways"
 },
 {
  "airlinecode": "HZ",
  "airlinename": "Sakhalinskie Aviatrassy"
 },
 {
  "airlinecode": "I5",
  "airlinename": "Compagnie Aerienne du Mali"
 },
 {
  "airlinecode": "I7",
  "airlinename": "Paramount Airways"
 },
 {
  "airlinecode": "I9",
  "airlinename": "Air-Service"
 },
 {
  "airlinecode": "IA",
  "airlinename": "Iraqi Airways"
 },
 {
  "airlinecode": "IC",
  "airlinename": "Indian Airlines"
 },
 {
  "airlinecode": "IG",
  "airlinename": "Meridiana Spa"
 },
 {
  "airlinecode": "IH",
  "airlinename": "Falcon Air"
 },
 {
  "airlinecode": "IJ",
  "airlinename": "Air Liberte"
 },
 {
  "airlinecode": "IK",
  "airlinename": "Imair"
 },
 {
  "airlinecode": "IM",
  "airlinename": "Intensive Air"
 },
 {
  "airlinecode": "H2",
  "airlinename": "SKY Airline"
 },
 {
  "airlinecode": "IN",
  "airlinename": "Mat Macedonia"
 },
 {
  "airlinecode": "IP",
  "airlinename": "Atyrau Airways"
 },
 {
  "airlinecode": "IS",
  "airlinename": "Island Airlines"
 },
 {
  "airlinecode": "IT",
  "airlinename": "Kingfisher"
 },
 {
  "airlinecode": "IW",
  "airlinename": "Air Lib"
 },
 {
  "airlinecode": "IY",
  "airlinename": "Yemen Airways Corporation"
 },
 {
  "airlinecode": "J0",
  "airlinename": "JETLINK EXPRE"
 },
 {
  "airlinecode": "J2",
  "airlinename": "Azerbaijan Airlines"
 },
 {
  "airlinecode": "J3",
  "airlinename": "Northwestern Air Lease"
 },
 {
  "airlinecode": "J6",
  "airlinename": "Larrys Flying"
 },
 {
  "airlinecode": "J8",
  "airlinename": "Berjaya Air"
 },
 {
  "airlinecode": "J9",
  "airlinename": "Jazeera Airways"
 },
 {
  "airlinecode": "JA",
  "airlinename": "Air Bosna"
 },
 {
  "airlinecode": "JB",
  "airlinename": "Helijet International"
 },
 {
  "airlinecode": "JC",
  "airlinename": "JAL Express"
 },
 {
  "airlinecode": "JE",
  "airlinename": "Manx Airlines"
 },
 
 {
  "airlinecode": "JH",
  "airlinename": "Nordeste-Linhas Aereas Regionais Sa"
 },
 {
  "airlinecode": "JI",
  "airlinename": "Midway Airlines"
 },
 {
  "airlinecode": "JK",
  "airlinename": "Spanair"
 },
 {
  "airlinecode": "JL",
  "airlinename": "Japan Airlines"
 },
 {
  "airlinecode": "JM",
  "airlinename": "Air Jamaica"
 },
 {
  "airlinecode": "JN",
  "airlinename": "Excel Airways"
 },
 {
  "airlinecode": "JO",
  "airlinename": "JALways"
 },
 {
  "airlinecode": "JP",
  "airlinename": "Adria Airways"
 },
 {
  "airlinecode": "JQ",
  "airlinename": "Jetstar"
 },
 {
  "airlinecode": "JR",
  "airlinename": "Aerocalfornia"
 },
 {
  "airlinecode": "JS",
  "airlinename": "Air Koryo"
 },
 {
  "airlinecode": "JV",
  "airlinename": "Bearskin Lake"
 },
 {
  "airlinecode": "JW",
  "airlinename": "Skippers Aviation"
 },
 {
  "airlinecode": "JZ",
  "airlinename": "Skyways Ab"
 },
 {
  "airlinecode": "K3",
  "airlinename": "Taquan Air Services"
 },
 {
  "airlinecode": "K4",
  "airlinename": "Kronflyg"
 },
 {
  "airlinecode": "K5",
  "airlinename": "Wings Alaska"
 },
 {
  "airlinecode": "K7",
  "airlinename": "Sakha Avia"
 },
 {
  "airlinecode": "K9",
  "airlinename": "Skyward Aviation"
 },
 {
  "airlinecode": "IQ",
  "airlinename": "Qazaq Air"
 },
 {
  "airlinecode": "KA",
  "airlinename": "Dragonair"
 },
 {
  "airlinecode": "KB",
  "airlinename": "Druk Air"
 },
 {
  "airlinecode": "KC",
  "airlinename": "Air Astana"
 },
 {
  "airlinecode": "KD",
  "airlinename": "KD Avia"
 },
 {
  "airlinecode": "KF",
  "airlinename": "Oy Air Botnia"
 },
 {
  "airlinecode": "KH",
  "airlinename": "Siem Reap Airways International"
 },
 {
  "airlinecode": "KI",
  "airlinename": "Time Air"
 },
 {
  "airlinecode": "KK",
  "airlinename": "Atlasjet Airlines"
 },
 {
  "airlinecode": "KO",
  "airlinename": "Alaska Central Express"
 },
 {
  "airlinecode": "KQ",
  "airlinename": "Kenya Airways"
 },
 {
  "airlinecode": "KS",
  "airlinename": "Penair"
 },
 {
  "airlinecode": "KV",
  "airlinename": "Kavminvodyavi"
 },
 {
  "airlinecode": "KW",
  "airlinename": "Air Company KAS"
 },
 {
  "airlinecode": "KX",
  "airlinename": "Cayman Airways"
 },
 {
  "airlinecode": "L2",
  "airlinename": "Lynden Air"
 },
 {
  "airlinecode": "L4",
  "airlinename": "Lauda-air S.p.A."
 },
 {
  "airlinecode": "L5",
  "airlinename": "Helikopter Service"
 },
 {
  "airlinecode": "L7",
  "airlinename": "Laoag International Airlines"
 },
 {
  "airlinecode": "L9",
  "airlinename": "Air Mali S.A."
 },
 {
  "airlinecode": "LB",
  "airlinename": "Boliviano"
 },
 {
  "airlinecode": "LC",
  "airlinename": "Legend Airlines"
 },
 {
  "airlinecode": "LE",
  "airlinename": "Helgoland Airlines"
 },
 {
  "airlinecode": "LF",
  "airlinename": "Nordic East"
 },
 {
  "airlinecode": "LG",
  "airlinename": "Luxair"
 },
 {
  "airlinecode": "LH",
  "airlinename": "Lufthansa"
 },
 {
  "airlinecode": "LI",
  "airlinename": "Liat"
 },
 {
  "airlinecode": "LK",
  "airlinename": "Air Luxor"
 },
 {
  "airlinecode": "LL",
  "airlinename": "Allegro"
 },
 {
  "airlinecode": "LN",
  "airlinename": "Libyan Arab Airlines"
 },
 {
  "airlinecode": "LS",
  "airlinename": "Iliamna Air"
 },
 {
  "airlinecode": "LT",
  "airlinename": "Lufttransport Uternehmen"
 },
 {
  "airlinecode": "LV",
  "airlinename": "Albanian Airlines Mak Shpk"
 },
 {
  "airlinecode": "LW",
  "airlinename": "Pacific Wings"
 },
 {
  "airlinecode": "KE",
  "airlinename": "Korean Air"
 },
 {
  "airlinecode": "LZ",
  "airlinename": "Balkan Bulgarian Airlines"
 },
 {
  "airlinecode": "m1",
  "airlinename": "TestAirLine"
 },
 {
  "airlinecode": "M5",
  "airlinename": "Kenmore"
 },
 {
  "airlinecode": "M9",
  "airlinename": "Motor Sich PISC"
 },
 {
  "airlinecode": "MA",
  "airlinename": "Malev Hungarian Airlines"
 },
 {
  "airlinecode": "MC",
  "airlinename": "Military Air"
 },
 {
  "airlinecode": "MF",
  "airlinename": "Xiamen Airlines"
 },
 {
  "airlinecode": "MH",
  "airlinename": "Malaysia Airlines"
 },
 {
  "airlinecode": "MI",
  "airlinename": "Silkair"
 },
 {
  "airlinecode": "MJ",
  "airlinename": "Lineas Aereas Privadas Argentinas"
 },
 {
  "airlinecode": "MK",
  "airlinename": "Air Mauritius"
 },
 {
  "airlinecode": "MM",
  "airlinename": "Medellin"
 },
 {
  "airlinecode": "MN",
  "airlinename": "Comair"
 },
 {
  "airlinecode": "MO",
  "airlinename": "Calm Air Intl"
 },
 {
  "airlinecode": "MQ",
  "airlinename": "American Eagle"
 },
 {
  "airlinecode": "MR",
  "airlinename": "Air Mauritani"
 },
 {
  "airlinecode": "MS",
  "airlinename": "Egyptair"
 },
 {
  "airlinecode": "MU",
  "airlinename": "China Eastern"
 },
 {
  "airlinecode": "MV",
  "airlinename": "Manus Air"
 },
 {
  "airlinecode": "MW",
  "airlinename": "Maya Airways"
 },
 {
  "airlinecode": "MX",
  "airlinename": "Mexicana"
 },
 {
  "airlinecode": "MY",
  "airlinename": "Sky Link Air"
 },
 {
  "airlinecode": "MZ",
  "airlinename": "Merpati Nusantara Dba Air Mali"
 },
 {
  "airlinecode": "N2",
  "airlinename": "Aerolineas Internacionales"
 },
 {
  "airlinecode": "N6",
  "airlinename": "Aero Continente"
 },
 {
  "airlinecode": "N9",
  "airlinename": "North Coast Aviation Pty"
 },
 {
  "airlinecode": "NA",
  "airlinename": "North American Airlines"
 },
 {
  "airlinecode": "NB",
  "airlinename": "Sterling"
 },
 {
  "airlinecode": "NC",
  "airlinename": "National Jet Systems Pty"
 },
 {
  "airlinecode": "ND",
  "airlinename": "Airlink Limited"
 },
 {
  "airlinecode": "NF",
  "airlinename": "Air Vanuatu"
 },
 {
  "airlinecode": "NG",
  "airlinename": "Lauda Air"
 },
 {
  "airlinecode": "NJ",
  "airlinename": "Vanguard Airlines"
 },
 {
  "airlinecode": "NK",
  "airlinename": "Spirit Airlines"
 },
 {
  "airlinecode": "NL",
  "airlinename": "Shaheen Air"
 },
 {
  "airlinecode": "NQ",
  "airlinename": "Air Japan"
 },
 {
  "airlinecode": "NT",
  "airlinename": "Binter Canarias"
 },
 {
  "airlinecode": "9P",
  "airlinename": "Fly Jinnah"
 },
 {
  "airlinecode": "NV",
  "airlinename": "Northwest Territorial Airways"
 },
 {
  "airlinecode": "NW",
  "airlinename": "Northwest Airlines"
 },
 {
  "airlinecode": "NY",
  "airlinename": "Air Iceland"
 },
 {
  "airlinecode": "OC",
  "airlinename": "Omni"
 },
 {
  "airlinecode": "OE",
  "airlinename": "Westair Commuter Airlines"
 },
 {
  "airlinecode": "OH",
  "airlinename": "Comair"
 },
 {
  "airlinecode": "OI",
  "airlinename": "Aspiring Air"
 },
 {
  "airlinecode": "OK",
  "airlinename": "Czech Airline"
 },
 {
  "airlinecode": "OL",
  "airlinename": "Ostfriesische Lufttransport Gmbh"
 },
 {
  "airlinecode": "OO",
  "airlinename": "Skywest Air"
 },
 {
  "airlinecode": "OP",
  "airlinename": "Chalk's Ocean Airways"
 },
 {
  "airlinecode": "OQ",
  "airlinename": "Sunrise Airlines"
 },
 {
  "airlinecode": "OR",
  "airlinename": "Crimea Air"
 },
 {
  "airlinecode": "OS",
  "airlinename": "Austrian Airlines"
 },
 {
  "airlinecode": "OT",
  "airlinename": "Aeropelican Air Services"
 },
 {
  "airlinecode": "OU",
  "airlinename": "Croatia Airlines"
 },

 {
  "airlinecode": "OX",
  "airlinename": "Orient Thai Airlines"
 },
 {
  "airlinecode": "OY",
  "airlinename": "OMNI AIR INTL"
 },
 {
  "airlinecode": "P2",
  "airlinename": "TyumenaviaTrans"
 },
 {
  "airlinecode": "P7",
  "airlinename": "East Line Airlines"
 },
 {
  "airlinecode": "P8",
  "airlinename": "Pantanal Linhas Aereas Sul"
 },
 {
  "airlinecode": "P9",
  "airlinename": "Pro Air"
 },
 {
  "airlinecode": "PB",
  "airlinename": "Provincial Airlines"
 },
 {
  "airlinecode": "PD",
  "airlinename": "Pem Air"
 },
 {
  "airlinecode": "PE",
  "airlinename": "Air Europe"
 },
 {
  "airlinecode": "PG",
  "airlinename": "Bangkok Airways"
 },
 {
  "airlinecode": "PH",
  "airlinename": "Polynesian Airlines"
 },
 {
  "airlinecode": "PI",
  "airlinename": "Sun Air Fiji"
 },
 {
  "airlinecode": "PJ",
  "airlinename": "Air Saint-Pierre"
 },
 {
  "airlinecode": "PK",
  "airlinename": "Pakistan International Airlines"
 },
 {
  "airlinecode": "PM",
  "airlinename": "Tropic Air"
 },
 {
  "airlinecode": "PR",
  "airlinename": "Philippine Airlines"
 },
 {
  "airlinecode": "PS",
  "airlinename": "Ukraine International Airlines"
 },
 {
  "airlinecode": "PF",
  "airlinename": "Air Sial"
 },
 {
  "airlinecode": "PT",
  "airlinename": "West Air Sweden"
 },
 {
  "airlinecode": "PV",
  "airlinename": "Saint Barth Commuter"
 },
 {
  "airlinecode": "PX",
  "airlinename": "Air Niugini"
 },
 {
  "airlinecode": "PY",
  "airlinename": "Surinam Airways"
 },
 {
  "airlinecode": "Q2",
  "airlinename": "Island Aviation Services"
 },
 {
  "airlinecode": "Q3",
  "airlinename": "Zambian Airways"
 },
 {
  "airlinecode": "Q5",
  "airlinename": "40 Mile Air"
 },
 {
  "airlinecode": "Q7",
  "airlinename": "Sobelair"
 },
 {
  "airlinecode": "Q8",
  "airlinename": "Pacific East Asia Cargo Airlines"
 },
 {
  "airlinecode": "QA",
  "airlinename": "Aerocaribe"
 },
 {
  "airlinecode": "QB",
  "airlinename": "Air Alma."
 },
 {
  "airlinecode": "QE",
  "airlinename": "Europ Continental Airways"
 },
 {
  "airlinecode": "QG",
  "airlinename": "Delta Air Transport"
 },
 {
  "airlinecode": "QJ",
  "airlinename": "Latpass Airlines"
 },
 {
  "airlinecode": "QK",
  "airlinename": "Air Nova"
 },
 {
  "airlinecode": "QL",
  "airlinename": "Aero Lanka"
 },
 {
  "airlinecode": "QM",
  "airlinename": "Air Malawi"
 },
 {
  "airlinecode": "QN",
  "airlinename": "Royal Aviation"
 },
 {
  "airlinecode": "QP",
  "airlinename": "Regional Air"
 },
 {
  "airlinecode": "QR",
  "airlinename": "Qatar Airways"
 },
 {
  "airlinecode": "QT",
  "airlinename": "Regional Air"
 },
 {
  "airlinecode": "QU",
  "airlinename": "Uganda Air"
 },
 {
  "airlinecode": "QX",
  "airlinename": "Horizon Airlines"
 },
 {
  "airlinecode": "QY",
  "airlinename": "European Air Transport"
 },
 {
  "airlinecode": "QZ",
  "airlinename": "P.T. Air Wagon International"
 },
 {
  "airlinecode": "R2",
  "airlinename": "State Orenburg Avia"
 },
 {
  "airlinecode": "R3",
  "airlinename": "Armenian Airlines"
 },
 {
  "airlinecode": "R4",
  "airlinename": "The State Transport Company Russia"
 },
 {
  "airlinecode": "R7",
  "airlinename": "Aserco Airlines"
 },
 {
  "airlinecode": "R9",
  "airlinename": "Camai Air"
 },
 {
  "airlinecode": "RA",
  "airlinename": "Royal Nepal Airlines Corp"
 },
 {
  "airlinecode": "RD",
  "airlinename": "Alitalia Team"
 },
 {
  "airlinecode": "RG",
  "airlinename": "Varig"
 },
 {
  "airlinecode": "RI",
  "airlinename": "P.T.Mandala Airlines"
 },
 {
  "airlinecode": "RJ",
  "airlinename": "Royal Jordanian"
 },
 {
  "airlinecode": "RK",
  "airlinename": "Air Afrique"
 },
 {
  "airlinecode": "RL",
  "airlinename": "Royal Phnom Penh Airways"
 },
 {
  "airlinecode": "RM",
  "airlinename": "Air Moldova I"
 },
 {
  "airlinecode": "RP",
  "airlinename": "Chantangua Airlines"
 },
 {
  "airlinecode": "RR",
  "airlinename": "Royal Air Force-38 Transport Group"
 },
 {
  "airlinecode": "RT",
  "airlinename": "Airlines Of South Australia"
 },
 {
  "airlinecode": "RV",
  "airlinename": "Caspian Air Lines"
 },
 {
  "airlinecode": "RW",
  "airlinename": "Ras Fluggesellschaft"
 },
 {
  "airlinecode": "RY",
  "airlinename": "European Executive Express"
 },
 {
  "airlinecode": "RZ",
  "airlinename": "Servicios Aereos Nacionales S A"
 },
 {
  "airlinecode": "S2",
  "airlinename": "JetLite"
 },
 {
  "airlinecode": "S3",
  "airlinename": "Santa Barbara Airlines"
 },
 {
  "airlinecode": "S5",
  "airlinename": "Shuttle America"
 },
 {
  "airlinecode": "S8",
  "airlinename": "Estonian Aviation Company"
 },
 {
  "airlinecode": "S9",
  "airlinename": "SWE Aviation Europe"
 },
 {
  "airlinecode": "SA",
  "airlinename": "South African Airways"
 },
 {
  "airlinecode": "SD",
  "airlinename": "Sudan Airways"
 },
 {
  "airlinecode": "SE",
  "airlinename": "Samoa Air"
 },
 {
  "airlinecode": "SG",
  "airlinename": "SpiceJet"
 },
 {
  "airlinecode": "SK",
  "airlinename": "Scandinavian Airlines System"
 },
 {
  "airlinecode": "SQ",
  "airlinename": "Singapore Airlines"
 },
 {
  "airlinecode": "SR",
  "airlinename": "Swiss Air Transport Co"
 },
 {
  "airlinecode": "SS",
  "airlinename": "Corsair International"
 },
 {
  "airlinecode": "ST",
  "airlinename": "Germania"
 },
 {
  "airlinecode": "SV",
  "airlinename": "Saudi Arabian Airlines"
 },
 {
  "airlinecode": "SW",
  "airlinename": "Air Namibia"
 },
 {
  "airlinecode": "SY",
  "airlinename": "Sun Country Airlines"
 },
 {
  "airlinecode": "T2",
  "airlinename": "Nakima Air Service"
 },
 {
  "airlinecode": "T3",
  "airlinename": "Eastern Airways"
 },
 {
  "airlinecode": "T4",
  "airlinename": "Hellas Jet"
 },
 {
  "airlinecode": "T5",
  "airlinename": "Turkmenistan"
 },
 {
  "airlinecode": "T6",
  "airlinename": "Tavrey Aircompany"
 },
 {
  "airlinecode": "T7",
  "airlinename": "Twin Jet"
 },
 {
  "airlinecode": "T8",
  "airlinename": "Transportes Aereos Nuequen"
 },
 {
  "airlinecode": "T9",
  "airlinename": "Varmlandsflyg"
 },
 {
  "airlinecode": "TE",
  "airlinename": "Lithuanian Airlines"
 },
 {
  "airlinecode": "TF",
  "airlinename": "Malmo Aviation"
 },
 {
  "airlinecode": "TG",
  "airlinename": "Thai Airways International"
 },
 {
  "airlinecode": "TH",
  "airlinename": "British Regional Airlines"
 },
 {
  "airlinecode": "TK",
  "airlinename": "Turkish Airlines"
 },
 {
  "airlinecode": "TL",
  "airlinename": "Airnorth Reg"
 },
 {
  "airlinecode": "TM",
  "airlinename": "Lam Linhas Aereas De Mocambique"
 },
 {
  "airlinecode": "TN",
  "airlinename": "Air Tahiti Nui"
 },
 {
  "airlinecode": "TO",
  "airlinename": "President Airlines"
 },
 {
  "airlinecode": "TQ",
  "airlinename": "Tandem Aero"
 },
 {
  "airlinecode": "TT",
  "airlinename": "Air Lithuania"
 },
 {
  "airlinecode": "TX",
  "airlinename": "Air Caraibes"
 },
 {
  "airlinecode": "TZ",
  "airlinename": "American Trans Air"
 },
 {
  "airlinecode": "U2",
  "airlinename": "Easyjet Airline Company"
 },
 {
  "airlinecode": "U4",
  "airlinename": "Buryat Airlines"
 },
 {
  "airlinecode": "U5",
  "airlinename": "USA 3000 Airlines"
 },
 {
  "airlinecode": "U6",
  "airlinename": "Ural Airlines"
 },
 {
  "airlinecode": "U7",
  "airlinename": "United Aviation"
 },
 {
  "airlinecode": "U9",
  "airlinename": "Tatarstan"
 },
 {
  "airlinecode": "UA",
  "airlinename": "United Airlines"
 },
 {
  "airlinecode": "UD",
  "airlinename": "Hex Air"
 },
 {
  "airlinecode": "UE",
  "airlinename": "Transeuropean Airlines"
 },
 {
  "airlinecode": "UG",
  "airlinename": "Tuninter"
 },
 {
  "airlinecode": "UH",
  "airlinename": "US Helicopter"
 },
 {
  "airlinecode": "UI",
  "airlinename": "Alaska Seaplane"
 },
 {
  "airlinecode": "UK",
  "airlinename": "Klm Uk"
 },
 {
  "airlinecode": "UL",
  "airlinename": "Sri Lankan Airlines"
 },
 {
  "airlinecode": "UM",
  "airlinename": "Air Zimbabwe"
 },
 {
  "airlinecode": "UO",
  "airlinename": "Hong Kong Express Airways"
 },
 {
  "airlinecode": "UP",
  "airlinename": "Bahamasair"
 },
 {
  "airlinecode": "US",
  "airlinename": "US Airways"
 },
 {
  "airlinecode": "UU",
  "airlinename": "Air Austral"
 },
 {
  "airlinecode": "UV",
  "airlinename": "Helicopteros Del Sureste"
 },
 {
  "airlinecode": "UW",
  "airlinename": "Perimeter Aviation"
 },
 {
  "airlinecode": "UX",
  "airlinename": "Air Europa"
 },
 {
  "airlinecode": "UY",
  "airlinename": "Cameroon Airlines"
 },
 {
  "airlinecode": "UZ",
  "airlinename": "U. P. Air"
 },
 {
  "airlinecode": "V3",
  "airlinename": "Carpatair"
 },
 {
  "airlinecode": "V4",
  "airlinename": "Vensecar International"
 },
 {
  "airlinecode": "V8",
  "airlinename": "TAPSA Aviacion"
 },
 {
  "airlinecode": "V9",
  "airlinename": "Bashkir Airlines"
 },
 {
  "airlinecode": "VB",
  "airlinename": "Maersk Air Lt"
 },
 {
  "airlinecode": "VC",
  "airlinename": "Servivensa"
 },
 {
  "airlinecode": "VF",
  "airlinename": "Nevis Express"
 },
 {
  "airlinecode": "VG",
  "airlinename": "VLM Airlines"
 },
 {
  "airlinecode": "VH",
  "airlinename": "Aeropostal Alas De Venezue"
 },
 {
  "airlinecode": "VK",
  "airlinename": "Virgin Express Ireland."
 },
 {
  "airlinecode": "VL",
  "airlinename": "North Vancouver Air"
 },
 {
  "airlinecode": "VM",
  "airlinename": "Regional Airlines"
 },
 {
  "airlinecode": "VN",
  "airlinename": "Vietnam Airlines"
 },
 {
  "airlinecode": "VO",
  "airlinename": "Tyrolean Air"
 },
 {
  "airlinecode": "VP",
  "airlinename": "Vasp Brazilian Airlines"
 },
 {
  "airlinecode": "VR",
  "airlinename": "Transportes Aereos De Cabo Verde"
 },
 {
  "airlinecode": "VS",
  "airlinename": "Virgin Atlantic Airways"
 },
 {
  "airlinecode": "VT",
  "airlinename": "Air Tahiti"
 },
 {
  "airlinecode": "VU",
  "airlinename": "Air Ivoire"
 },
 {
  "airlinecode": "VV",
  "airlinename": "Aerosvit Airlines"
 },
 {
  "airlinecode": "VW",
  "airlinename": "Aeromar Airlines"
 },
 {
  "airlinecode": "VX",
  "airlinename": "Aces"
 },
 {
  "airlinecode": "VZ",
  "airlinename": "Air Tours Intl Airways"
 },
 {
  "airlinecode": "W3",
  "airlinename": "Swiftair"
 },
 {
  "airlinecode": "W5",
  "airlinename": "Mahan Air"
 },
 {
  "airlinecode": "W6",
  "airlinename": "West Isle Air"
 },
 {
  "airlinecode": "W7",
  "airlinename": "Sayakhat Air Company"
 },
 {
  "airlinecode": "w9",
  "airlinename": "Jet Airways (INTL)"
 },
 {
  "airlinecode": "WA",
  "airlinename": "Klm Cityhoppe"
 },
 {
  "airlinecode": "WB",
  "airlinename": "Rwandair Express"
 },
 {
  "airlinecode": "WC",
  "airlinename": "Islena Airl"
 },
 {
  "airlinecode": "WD",
  "airlinename": "Halisa Air"
 },
 {
  "airlinecode": "WE",
  "airlinename": "Challenge"
 },
 {
  "airlinecode": "WH",
  "airlinename": "China N West"
 },
 {
  "airlinecode": "WJ",
  "airlinename": "Labrador Airways"
 },
 {
  "airlinecode": "WL",
  "airlinename": "Aeroperlas"
 },
 {
  "airlinecode": "WM",
  "airlinename": "Windward Islands Airways Intl"
 },
 {
  "airlinecode": "WP",
  "airlinename": "Island Air"
 },
 {
  "airlinecode": "WQ",
  "airlinename": "Romavia"
 },
 {
  "airlinecode": "WR",
  "airlinename": "Royal Tongan"
 },
 {
  "airlinecode": "WS",
  "airlinename": "Westjet Airlines"
 },
 {
  "airlinecode": "WZ",
  "airlinename": "Acvila Air"
 },
 {
  "airlinecode": "X5",
  "airlinename": "Cronus Air"
 },
 {
  "airlinecode": "XF",
  "airlinename": "Vladivostok Air"
 },
 {
  "airlinecode": "XH",
  "airlinename": "Hndlg Angent"
 },
 {
  "airlinecode": "xi",
  "airlinename": "Air India Expres (Intl)"
 },
 {
  "airlinecode": "XJ",
  "airlinename": "Mesaba Aviation"
 },
 {
  "airlinecode": "XM",
  "airlinename": "Alitalia Express"
 },
 {
  "airlinecode": "XN",
  "airlinename": "Xpress Air"
 },
 {
  "airlinecode": "XO",
  "airlinename": "China Xinjiang Airl"
 },
 {
  "airlinecode": "XQ",
  "airlinename": "SunExpress"
 },
 {
  "airlinecode": "XR",
  "airlinename": "Skywest Airlines"
 },
 {
  "airlinecode": "XT",
  "airlinename": "Klm Exel"
 },
 {
  "airlinecode": "XW",
  "airlinename": "China Xinhua Airlines"
 },
 {
  "airlinecode": "Y2",
  "airlinename": "Alliance Air"
 },
 {
  "airlinecode": "Y9",
  "airlinename": "Trans Air Congo"
 },
 {
  "airlinecode": "YB",
  "airlinename": "South African Express Airlines"
 },
 {
  "airlinecode": "YC",
  "airlinename": "Flight West"
 },
 {
  "airlinecode": "YI",
  "airlinename": "Air Sunshine"
 },
 {
  "airlinecode": "YJ",
  "airlinename": "National Air"
 },
 {
  "airlinecode": "YK",
  "airlinename": "Kibris Turkish Airlines"
 },
 {
  "airlinecode": "YM",
  "airlinename": "Montenegro Airlines"
 },
 {
  "airlinecode": "YN",
  "airlinename": "Air Creebec"
 },
 {
  "airlinecode": "YO",
  "airlinename": "Heli Air Monaco"
 },
 {
  "airlinecode": "YQ",
  "airlinename": "Euro Air Heli"
 },
 {
  "airlinecode": "YR",
  "airlinename": "Scenic Air Lines"
 },
 {
  "airlinecode": "YS",
  "airlinename": "Proteus"
 },
 {
  "airlinecode": "YT",
  "airlinename": "YETI AIRLINES"
 },
 {
  "airlinecode": "YV",
  "airlinename": "Mesa Aviation Services"
 },
 {
  "airlinecode": "YW",
  "airlinename": "Air Nostrum"
 },
 {
  "airlinecode": "YX",
  "airlinename": "Midwest Express Airlines"
 },
 {
  "airlinecode": "Z3",
  "airlinename": "Promech"
 },
 {
  "airlinecode": "Z4",
  "airlinename": "Tayfunair"
 },
 {
  "airlinecode": "Z5",
  "airlinename": "Gmg Airlines"
 },
 {
  "airlinecode": "Z6",
  "airlinename": "Dnieproavia Joint Stock Aviation Company"
 },
 {
  "airlinecode": "Z8",
  "airlinename": "Pulkovo Aviation Enterprise"
 },
 {
  "airlinecode": "ZA",
  "airlinename": "AccessAir"
 },
 {
  "airlinecode": "ZB",
  "airlinename": "Monarch Airln"
 },
 {
  "airlinecode": "ZH",
  "airlinename": "Shenzhen Airlines"
 },
 {
  "airlinecode": "ZI",
  "airlinename": "Aigle Azur Transport Ariens"
 },
 {
  "airlinecode": "ZK",
  "airlinename": "Great Lakes"
 },
 {
  "airlinecode": "ZL",
  "airlinename": "Hazelton Air Services Pty"
 },
 {
  "airlinecode": "ZN",
  "airlinename": "Eagle Air"
 },
 {
  "airlinecode": "ZO",
  "airlinename": "Great Plains Airlines"
 },
 {
  "airlinecode": "ZR",
  "airlinename": "Muk Air"
 },
 {
  "airlinecode": "ZS",
  "airlinename": "Sama Airlines"
 },
 {
  "airlinecode": "ZT",
  "airlinename": "Air Zambezi"
 },
 {
  "airlinecode": "ZV",
  "airlinename": "Air Midwest"
 },
 {
  "airlinecode": "ZW",
  "airlinename": "Air Wisconsin"
 },
 {
  "airlinecode": "ZX",
  "airlinename": "Air British Columbia"
 },
 {
  "airlinecode": "ZY",
  "airlinename": "Ada Air"
 },
 {
  "airlinecode": "PC",
  "airlinename": "Pegasus Airlines"
 },
 {
  "airlinecode": "15",
  "airlinename": "Bronze"
 },
 {
  "airlinecode": "16",
  "airlinename": "OK"
 },
 {
  "airlinecode": "P1",
  "airlinename": "Holiday Packages"
 },
 {
  "airlinecode": "O1",
  "airlinename": "Bus Visa Change"
 },
 {
  "airlinecode": "11",
  "airlinename": "BSP"
 },
 {
  "airlinecode": "V1",
  "airlinename": "Air Arabia "
 },
 {
  "airlinecode": "ZP",
  "airlinename": "Paranair"
 },
 {
  "airlinecode": "IX",
  "airlinename": "Air India Express"
 },
 {
  "airlinecode": "wdewd",
  "airlinename": "string"
 },
 {
  "airlinecode": "string",
  "airlinename": "string"
 },
 {
  "airlinecode": "EK",
  "airlinename": "Emirates Airlines"
 },
 {
  "airlinecode": "LA",
  "airlinename": "LATAM Airlines Group"
 },
 {
  "airlinecode": "CL",
  "airlinename": "Lufthansa CityLine"
 },
 {
  "airlinecode": "CM",
  "airlinename": "COPA Airlines"
 },
 {
  "airlinecode": "CU",
  "airlinename": "Cubana"
 },
 {
  "airlinecode": "CV",
  "airlinename": "Cargolux"
 },
 {
  "airlinecode": "CX",
  "airlinename": "Cathay Pacific"
 },
 {
  "airlinecode": "CZ",
  "airlinename": "China Southern Airlines"
 },
 {
  "airlinecode": "D4",
  "airlinename": "Airline Geosky"
 },
 {
  "airlinecode": "DD",
  "airlinename": "Nok Air"
 },
 {
  "airlinecode": "DE",
  "airlinename": "Condor"
 },
 {
  "airlinecode": "DN",
  "airlinename": "DAN AIR"
 },
 {
  "airlinecode": "DR",
  "airlinename": "Ruili Airlines"
 },
 {
  "airlinecode": "DT",
  "airlinename": "TAAG Angola Airlines"
 },
 {
  "airlinecode": "DV",
  "airlinename": "SCAT Airlines"
 },
 {
  "airlinecode": "EI",
  "airlinename": "Aer Lingus"
 },
 {
  "airlinecode": "EO",
  "airlinename": "Ikar"
 },
 {
  "airlinecode": "ET",
  "airlinename": "Ethiopian Airlines"
 },
 {
  "airlinecode": "F3",
  "airlinename": "flyadeal"
 },
 {
  "airlinecode": "F6",
  "airlinename": "Fly2Sky"
 },
 {
  "airlinecode": "FB",
  "airlinename": "Bulgaria Air"
 },
 {
  "airlinecode": "FC",
  "airlinename": "Link Airways"
 },
 {
  "airlinecode": "FJ",
  "airlinename": "Fiji Airways"
 },
 {
  "airlinecode": "FN",
  "airlinename": "Fastjet Zimbabwe"
 },
 {
  "airlinecode": "FU",
  "airlinename": "Fuzhou Airlines"
 },
 {
  "airlinecode": "FZ",
  "airlinename": "Fly Dubai"
 },
 {
  "airlinecode": "G3",
  "airlinename": "GOL Linhas Aereas"
 },
 {
  "airlinecode": "G5",
  "airlinename": "China Express Airlines"
 },
 {
  "airlinecode": "G6",
  "airlinename": "GlobalX"
 },
 {
  "airlinecode": "GA",
  "airlinename": "Garuda Indonesia"
 },
 {
  "airlinecode": "GJ",
  "airlinename": "Loong Air"
 },
 {
  "airlinecode": "GO",
  "airlinename": "ULS Airlines Cargo"
 },
 {
  "airlinecode": "GQ",
  "airlinename": "Sky express"
 },
 {
  "airlinecode": "GS",
  "airlinename": "Tianjin Airlines"
 },
 {
  "airlinecode": "GT",
  "airlinename": "Air Guilin"
 },
 {
  "airlinecode": "GX",
  "airlinename": "GX Airlines"
 },
 {
  "airlinecode": "H3",
  "airlinename": "Hello Jets"
 },
 {
  "airlinecode": "H9",
  "airlinename": "Himalaya Airlines"
 },
 {
  "airlinecode": "HB",
  "airlinename": "Greater Bay Airlines"
 },
 {
  "airlinecode": "HM",
  "airlinename": "Air Seychelles"
 },
 {
  "airlinecode": "HN",
  "airlinename": "Heston Airlines"
 },
 {
  "airlinecode": "ABC1234",
  "airlinename": "Sample Airline"
 },
 {
  "airlinecode": "GMG001"
 },
 {
  "airlinecode": "AER",
  "airlinename": "AERAIRLINES"
 },
 {
  "airlinecode": "KP",
  "airlinename": "Asky Airlines"
 },
 {
  "airlinecode": "2K",
  "airlinename": "Avianca Ecuador"
 },
 {
  "airlinecode": "2P",
  "airlinename": "Air Philippines"
 },
 {
  "airlinecode": "2S",
  "airlinename": "Southwind Airlines"
 },
 {
  "airlinecode": "2W",
  "airlinename": "World2Fly"
 },
 {
  "airlinecode": "2Z",
  "airlinename": "Voepass Linhas Aereas"
 },
 {
  "airlinecode": "4C",
  "airlinename": "LATAM Airlines Colombia"
 },
 {
  "airlinecode": "4M",
  "airlinename": "Mavi Gök Airlines (MGA)"
 },
 {
  "airlinecode": "4S",
  "airlinename": "Red Sea Airlines"
 },
 {
  "airlinecode": "5H",
  "airlinename": "ASL Airlines Ireland"
 },
 {
  "airlinecode": "5N",
  "airlinename": "Smartavia"
 },
 {
  "airlinecode": "5Y",
  "airlinename": "Atlas Air"
 },
 {
  "airlinecode": "7H",
  "airlinename": "New Pacific Airlines"
 },
 {
  "airlinecode": "7R",
  "airlinename": "RusLine"
 },
 {
  "airlinecode": "8M",
  "airlinename": "Myanmar Airways International"
 },
 {
  "airlinecode": "9H",
  "airlinename": "Air Changan"
 },
 {
  "airlinecode": "A9",
  "airlinename": "Georgian Airways"
 },
 {
  "airlinecode": "AH",
  "airlinename": "Air Algérie"
 },
 {
  "airlinecode": "AM",
  "airlinename": "Aeromexico"
 },
 {
  "airlinecode": "AP",
  "airlinename": "Albastar"
 },
 {
  "airlinecode": "AV",
  "airlinename": "Avianca"
 },
 {
  "airlinecode": "AW",
  "airlinename": "Africa World Airlines"
 },
 {
  "airlinecode": "AZ",
  "airlinename": "ITA Airways"
 },
 {
  "airlinecode": "B2",
  "airlinename": "Belavia Belarusian Airlines"
 },
 {
  "airlinecode": "B5",
  "airlinename": "BBN Airlines"
 },
 {
  "airlinecode": "B6",
  "airlinename": "JetBlue"
 },
 {
  "airlinecode": "B7",
  "airlinename": "UNI AIR"
 },
 {
  "airlinecode": "B9",
  "airlinename": "Iran Airtour Airline"
 },
 {
  "airlinecode": "BF",
  "airlinename": "French Bee"
 },
 {
  "airlinecode": "BI",
  "airlinename": "Royal Brunei Airlines"
 },
 {
  "airlinecode": "BS",
  "airlinename": "US-Bangla Airlines"
 },
 {
  "airlinecode": "BW",
  "airlinename": "Caribbean Airlines"
 },
 {
  "airlinecode": "BZ",
  "airlinename": "Blue Bird Airways"
 },
 {
  "airlinecode": "CC",
  "airlinename": "Air Atlanta Icelandic"
 },
 {
  "airlinecode": "CE",
  "airlinename": "Chalair"
 },
 {
  "airlinecode": "CF",
  "airlinename": "China Postal Airlines"
 },
 {
  "airlinecode": "CI",
  "airlinename": "China Airlines"
 },
 {
  "airlinecode": "CK",
  "airlinename": "China Cargo Airlines"
 },
 {
  "airlinecode": "HO",
  "airlinename": "Juneyao Airlines"
 },
 {
  "airlinecode": "HP",
  "airlinename": "PopulAir"
 },
 {
  "airlinecode": "HX",
  "airlinename": "Hong Kong Airlines"
 },
 {
  "airlinecode": "IB",
  "airlinename": "IBERIA"
 },
 {
  "airlinecode": "IE",
  "airlinename": "Solomon Airlines"
 },
 {
  "airlinecode": "IR",
  "airlinename": "Iran Air"
 },
 {
  "airlinecode": "IZ",
  "airlinename": "Arkia Israeli Airlines"
 },
 {
  "airlinecode": "J4",
  "airlinename": "Badr Airlines"
 },
 {
  "airlinecode": "J7",
  "airlinename": "Afrijet"
 },
 {
  "airlinecode": "JD",
  "airlinename": "Capital Airlines"
 },
 {
  "airlinecode": "JJ",
  "airlinename": "LATAM Airlines Brasil"
 },
 {
  "airlinecode": "JT",
  "airlinename": "Lion Air"
 },
 {
  "airlinecode": "JU",
  "airlinename": "Air Serbia"
 },
 {
  "airlinecode": "JX",
  "airlinename": "STARLUX Airlines"
 },
 {
  "airlinecode": "K6",
  "airlinename": "Air Cambodia"
 },
 {
  "airlinecode": "KJ",
  "airlinename": "Air Incheon"
 },
 {
  "airlinecode": "KL",
  "airlinename": "Klm Royal Dutch Airlines"
 },
 {
  "airlinecode": "KM",
  "airlinename": "KM Malta Airlines"
 },
 {
  "airlinecode": "KU",
  "airlinename": "Kuwait Airways"
 },
 {
  "airlinecode": "KY",
  "airlinename": "Kunming Airlines"
 },
 {
  "airlinecode": "L6",
  "airlinename": "Mauritania Airlines International"
 },
 {
  "airlinecode": "LD",
  "airlinename": "Air Hong Kong"
 },
 {
  "airlinecode": "LJ",
  "airlinename": "Jin Air"
 },
 {
  "airlinecode": "LM",
  "airlinename": "Loganair"
 },
 {
  "airlinecode": "LO",
  "airlinename": "LOT Polish Airlines"
 },
 {
  "airlinecode": "LP",
  "airlinename": "LATAM Airlines Peru"
 },
 {
  "airlinecode": "LR",
  "airlinename": "Avianca Costa Rica"
 },
 {
  "airlinecode": "LX",
  "airlinename": "SWISS"
 },
 {
  "airlinecode": "LY",
  "airlinename": "El Al Israel Airlines Limited"
 },
 {
  "airlinecode": "M3",
  "airlinename": "LATAM Cargo Brasil"
 },
 {
  "airlinecode": "M4",
  "airlinename": "Poste Air Cargo"
 },
 {
  "airlinecode": "MD",
  "airlinename": "Madagascar Airlines"
 },
 {
  "airlinecode": "ME",
  "airlinename": "Middle East Airlines Airliban"
 },
 {
  "airlinecode": "MG",
  "airlinename": "Eznis Airways"
 },
 {
  "airlinecode": "MP",
  "airlinename": "Martinair Cargo"
 },
 {
  "airlinecode": "N7",
  "airlinename": "Norra"
 },
 {
  "airlinecode": "NE",
  "airlinename": "Nesma Airlines"
 },
 {
  "airlinecode": "NH",
  "airlinename": "ANA"
 },
 {
  "airlinecode": "NI",
  "airlinename": "PGA-Portugalia Airlines"
 },
 {
  "airlinecode": "NU",
  "airlinename": "Japan Transocean Air"
 },
 {
  "airlinecode": "NX",
  "airlinename": "Air Macau"
 },
 {
  "airlinecode": "NZ",
  "airlinename": "Air New Zealand"
 },
 {
  "airlinecode": "OA",
  "airlinename": "Olympic Air"
 },
 {
  "airlinecode": "OB",
  "airlinename": "BoA Boliviana de Aviacion"
 },
 {
  "airlinecode": "OD",
  "airlinename": "Batik Air Malaysia"
 },
 {
  "airlinecode": "OM",
  "airlinename": "MIAT Mongolian Airlines"
 },
 {
  "airlinecode": "ON",
  "airlinename": "Nauru Airlines"
 },
 {
  "airlinecode": "OV",
  "airlinename": "Salam Air"
 },
 {
  "airlinecode": "OZ",
  "airlinename": "Asiana Airlines"
 },
 {
  "airlinecode": "P4",
  "airlinename": "Air Peace"
 },
 {
  "airlinecode": "P5",
  "airlinename": "Aero Republica"
 },
 {
  "airlinecode": "P6",
  "airlinename": "Privilege Style"
 },
 {
  "airlinecode": "PN",
  "airlinename": "West Air"
 },
 {
  "airlinecode": "PU",
  "airlinename": "Plus Ultra"
 },
 {
  "airlinecode": "PW",
  "airlinename": "Precision Air"
 },
 {
  "airlinecode": "PZ",
  "airlinename": "LATAM Airlines Paraguay"
 },
 {
  "airlinecode": "QC",
  "airlinename": "Camair-Co"
 },
 {
  "airlinecode": "QF",
  "airlinename": "Qantas"
 },
 {
  "airlinecode": "QI",
  "airlinename": "Ibom Air"
 },
 {
  "airlinecode": "QS",
  "airlinename": "Smartwings"
 },
 {
  "airlinecode": "QV",
  "airlinename": "Lao Airlines"
 },
 {
  "airlinecode": "QW",
  "airlinename": "Qingdao Airlines"
 },
 {
  "airlinecode": "R5",
  "airlinename": "Jordan Aviation"
 },
 {
  "airlinecode": "R6",
  "airlinename": "DAT (LT)"
 },
 {
  "airlinecode": "RB",
  "airlinename": "Syrianair"
 },
 {
  "airlinecode": "RC",
  "airlinename": "Atlantic Airways"
 },
 {
  "airlinecode": "RE",
  "airlinename": "Airhub Airlines"
 },
 {
  "airlinecode": "RH",
  "airlinename": "Hong Kong Air Cargo"
 },
 {
  "airlinecode": "RO",
  "airlinename": "TAROM"
 },
 {
  "airlinecode": "RQ",
  "airlinename": "Kam Air"
 },
 {
  "airlinecode": "RU",
  "airlinename": "AirBridgeCargo Airlines"
 },
 {
  "airlinecode": "S4",
  "airlinename": "Azores Airlines"
 },
 {
  "airlinecode": "S7",
  "airlinename": "S7 Airlines"
 },
 {
  "airlinecode": "SB",
  "airlinename": "Aircalin"
 },
 {
  "airlinecode": "SC",
  "airlinename": "Shandong Airlines"
 },
 {
  "airlinecode": "SL",
  "airlinename": "Thai Lion Air"
 },
 {
  "airlinecode": "SM",
  "airlinename": "Air Cairo"
 },
 {
  "airlinecode": "SN",
  "airlinename": "Brussels Airlines"
 },
 {
  "airlinecode": "SP",
  "airlinename": "Sociedade Acoreana De Transportes"
 },
 {
  "airlinecode": "SU",
  "airlinename": "Aeroflot"
 },
 {
  "airlinecode": "SZ",
  "airlinename": "Somon Air"
 },
 {
  "airlinecode": "TA",
  "airlinename": "TACA"
 },
 {
  "airlinecode": "TC",
  "airlinename": "Air Tanzania"
 },
 {
  "airlinecode": "TP",
  "airlinename": "TAP Air Portugal"
 },
 {
  "airlinecode": "TR",
  "airlinename": "Scoot"
 },
 {
  "airlinecode": "TS",
  "airlinename": "Air Transat"
 },
 {
  "airlinecode": "TU",
  "airlinename": "Tunisair"
 },
 {
  "airlinecode": "TV",
  "airlinename": "Tibet Airlines"
 },
 {
  "airlinecode": "TY",
  "airlinename": "Air Caledonie"
 },
 {
  "airlinecode": "U8",
  "airlinename": "TUS Airways"
 },
 {
  "airlinecode": "UB",
  "airlinename": "Myanmar National Airlines"
 },
 {
  "airlinecode": "UC",
  "airlinename": "LATAM Cargo Chile"
 },
 {
  "airlinecode": "UF",
  "airlinename": "Petroleum Air Services"
 },
 {
  "airlinecode": "UJ",
  "airlinename": "AlMasria Universal Airlines"
 },
 {
  "airlinecode": "UN",
  "airlinename": "United Nigeria Airlines"
 },
 {
  "airlinecode": "UQ",
  "airlinename": "Urumqi Air"
 },
 {
  "airlinecode": "UT",
  "airlinename": "UTair"
 },
 {
  "airlinecode": "V7",
  "airlinename": "Volotea"
 },
 {
  "airlinecode": "VA",
  "airlinename": "Virgin Australia"
 },
 {
  "airlinecode": "VE",
  "airlinename": "Clic Air"
 },
 {
  "airlinecode": "VJ",
  "airlinename": "Vietjet"
 },
 {
  "airlinecode": "VY",
  "airlinename": "Vueling"
 },
 {
  "airlinecode": "W2",
  "airlinename": "FlexFlight"
 },
 {
  "airlinecode": "WF",
  "airlinename": "Wideroe"
 },
 {
  "airlinecode": "WK",
  "airlinename": "Edelweiss Air"
 },
 {
  "airlinecode": "WN",
  "airlinename": "Southwest Airlines"
 },
 {
  "airlinecode": "WT",
  "airlinename": "Swiftair"
 },
 {
  "airlinecode": "WV",
  "airlinename": "Fly Namibia"
 },
 {
  "airlinecode": "WX",
  "airlinename": "CityJet"
 },
 {
  "airlinecode": "WY",
  "airlinename": "Oman Air"
 },
 {
  "airlinecode": "X3",
  "airlinename": "TUIfly"
 },
 {
  "airlinecode": "X7",
  "airlinename": "Challenge Airlines (BE)"
 },
 {
  "airlinecode": "X9",
  "airlinename": "Avion Express"
 },
 {
  "airlinecode": "XK",
  "airlinename": "Air Corsica"
 },
 {
  "airlinecode": "XL",
  "airlinename": "LATAM Airlines Ecuador"
 },
 {
  "airlinecode": "XY",
  "airlinename": "Flynas"
 },
 {
  "airlinecode": "Y4",
  "airlinename": "Volaris"
 },
 {
  "airlinecode": "Y8",
  "airlinename": "Suparna Airlines"
 },
 {
  "airlinecode": "YP",
  "airlinename": "Air Premia"
 },
 {
  "airlinecode": "X1",
  "airlinename": "Hahn Air"
 }

];
